document.addEventListener("DOMContentLoaded", () => {
  const navItems = document.querySelectorAll(".mega-menu__link");
  const drawerNavItems = document.querySelectorAll('.menu-drawer__list-item')
  const closeBtn = document.querySelectorAll('.menu-child-close')
  const details = document.querySelectorAll('.details-menu-content')

  navItems.forEach((item) => {
    item.addEventListener("mouseenter", function () {
      if (!item.classList.contains("active")) {
        const parent = item.closest(".secondary-nav-layout");
        const equalItems = parent.querySelectorAll(".mega-menu__link");
        const itemProducts = parent.querySelectorAll(".secondary-nav-product-list");
        const index = item.getAttribute('index')

        equalItems.forEach((el) => el.classList.remove("active"));
        item.classList.add("active");

        itemProducts.forEach((content) => {
            const sequence = content.getAttribute('index')
            content.classList.remove("active")
            if (index == sequence) {
                content.classList.add("active")
            }
        })
      }
    });
  });

  drawerNavItems.forEach((item) => {
    item.addEventListener('click', function () {
      const itemProducts = item.querySelector('.secondary-nav-product-list')
      const arrowhead = item.querySelector('.menu-child-arrowhead')

       if (item.classList.contains("active")) {
        item.classList.remove("active")
        itemProducts.classList.remove("active")
        arrowhead.classList.remove("active")
       } else {
        item.classList.add("active")
        itemProducts.classList.add("active")
        arrowhead.classList.add("active")
       }
    })
  })

  closeBtn.forEach((item) => {
    item.addEventListener('click', function() {
      details.forEach((el) => {
        el.removeAttribute('open')
      })
    })
  })
  
});
